module.exports = "<div>\n\n  <div *ngIf=\"!isSuccess\">\n    <div class=\" \">\n      <div class=\"col-md-12 okdiv\">\n        <wait-for-payment></wait-for-payment>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"isSuccess\">\n    <div class=\"row\">\n      <div class=\"col-md-12 okdiv\">\n        <div *ngIf=\"okmessage\" [innerHTML]=\"okmessage\"></div>\n        <button (click)=\"goToMain()\" class=\"round okbutton\">עמוד הראשי</button>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/ok.component.html
// module id = ./src/app/payment/ok.component.html
// module chunks = main